import React, { FC } from 'react';
import { FormattedMessage } from 'react-intl';
import { Connect, PropsFromRedux } from './LegalBasisSnippetContainer';
import styles from './legal_basis.module.scss';
import { LegalBasisSnippetAccordion } from './LegalBasisSnippetAccordion';
import { AnimatedLink } from '../../../../../components/animated-link/AnimatedLink';
import { buildUrlWithParameters } from '../../../../../utils/url-utils/urlUtils';
import { NoLinkLegislationTitle } from './NoLinkLegislationTitle';
import { doctrineAnalytics } from '../../../../../utils/analyticsUtils';
import { withUser } from '../../../../../user/UserContext';
import {
  withRestrictedModal,
  WithRestrictedModalProps,
} from '../../../../../components/modal/components/modal-restricted/withRestrictedModal';
import { UserContextType } from '../../../../../user/user.types';
import { Paper } from '../../../../../components/paper/Paper';

type Props = PropsFromRedux & UserContextType & WithRestrictedModalProps;

const source = 'legal-basis-snippet';

export const RawLegalBasisSnippet: FC<Props> = ({
  legalBasis,
  query,
  searchQueryUrl,
  accessPremium,
  openRestrictedModal,
}) => {
  const legislationSearchUrl = buildUrlWithParameters('/search', {
    q: query,
    type: 'law',
  });

  if (!legalBasis || legalBasis.length === 0) {
    return null;
  }

  const reportOnOpenToNewTabAndBasicClick = () => {
    doctrineAnalytics('Search TypeOfResultChanged', {
      type: 'law',
      source: 'legal-basis-snippet',
    });
  };

  return (
    <Paper className={styles.container}>
      <div className={styles.header}>
        <FormattedMessage id="search/components/search-snippets/aside/legal-basis/LegalBasisSnippet.tsx/1" />
      </div>
      {legalBasis.map((legislation, index) => (
        // eslint-disable-next-line react/no-array-index-key
        <div className={styles.legislation} key={index}>
          <NoLinkLegislationTitle>
            {legislation.mainTitle}
          </NoLinkLegislationTitle>
          <LegalBasisSnippetAccordion
            isFirst={index === 0}
            searchQueryUrl={searchQueryUrl}
            legislation={legislation}
            eventName="Search LegislationExpanded"
            source="legal-basis-snippet"
          />
        </div>
      ))}
      <div className={styles.footer}>
        <AnimatedLink
          {...(accessPremium
            ? {
                href: legislationSearchUrl,
                source,
                onMouseDown: reportOnOpenToNewTabAndBasicClick,
              }
            : {
                onClick: () => openRestrictedModal(source),
              })}
        >
          <FormattedMessage id="search/components/search-snippets/aside/legal-basis/LegalBasisSnippet.tsx/2" />
        </AnimatedLink>
      </div>
    </Paper>
  );
};

export const LegalBasisSnippet = Connect(
  withUser(withRestrictedModal(RawLegalBasisSnippet)),
);
